import { FIELD_TYPES, FIELD_TYPES_CATEGORIES } from './fieldTypes.tsx';
import type { FieldType } from './FieldType.types.tsx';

export const getUnsupportedFieldsForPinning: () => FieldType[] = () => [
	...FIELD_TYPES_CATEGORIES.ARCHIVED,
	FIELD_TYPES.DESCRIPTION,
	FIELD_TYPES.ISSUE_ID,
	FIELD_TYPES.ISSUE_TYPE,
	FIELD_TYPES.CONNECTION,
	FIELD_TYPES.ISSUE_COMMENTS,
	FIELD_TYPES.ISSUE_KEY,
	FIELD_TYPES.SUMMARY,
	FIELD_TYPES.PROJECT,
];
